import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import LoadStyles from '@driftt/tide-core/dist/styles'

import history from 'modules/history'
import store from 'modules/store'
import App from 'layouts/App'
import { initializeSentry } from 'utils/logger'

initializeSentry()
LoadStyles()

ReactDOM.render(
  <Provider store={store}>
    <App history={history}/>
  </Provider>,
  document.getElementById('root')
)
